import Big from 'big.js'
// 金额保留2位小数
export function round2Places(d,decimals = 2) {
  return d !== '' ? Big(d).round(decimals, Big.roundDown).toNumber() : d;
}

  /*
  * 格式化数字
  * number：要格式化的数字
  * decimals：保留几位小数
  * dec_point：小数点符号
  * thousands_sep：千分位符号
  * */
export function formatNumber(number, decimals, dec_point, thousands_sep) {
  number = (number + '').replace(/[^0-9+-Ee.]/g, '');
  let n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
      dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
      s = '';

  const toFixedFix = function (n, prec) {
      const k = Math.pow(10, prec);
      return '' + Math.floor(n * k) / k;
  };

  s = (prec ? toFixedFix(n, prec) : '' + Math.floor(n)).split('.');
  const re = /(-?\d+)(\d{3})/;

  while (re.test(s[0])) {
      s[0] = s[0].replace(re, "$1" + sep + "$2");
  }

  if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}

export function isFunction(fn) {
  return Object.prototype.toString.call(fn) === '[object Function]';
}

export function isObject(obj) {
  var type = typeof obj;
  return type === 'function' || type === 'object' && !!obj;
}

export function isUndef(val) {
  return typeof val === 'undefined';
}

function isPromise(obj) {
  return 'function' == typeof obj.then;
}

export function isString(val) {
  return typeof val === 'string';
}

// 保证fn返回resolve状态
function toResolvedPromise(fn) {
  return new Promise((resolve, reject) => {
    let result = fn();

    // 非promise结果直接返回
    if (!isPromise(result)) {
      console.log('not promise');
      return resolve(result)
    }

    result.then((data) => {
      resolve(data)
    }).catch((err) => {
      console.log('error:', err);
      resolve(null);
    })
  })
}

// 顺序执行promise
export function runPromiseInSequence(promiseArr) {
  const arr = [];
  async function run() {
    for(let p of promiseArr) {
      const val = await toResolvedPromise(p);
      arr.push(val);
    }
    return arr;
  }
  return run();
}

// 获取URL 参数
export function getUrlParam (name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || '';
}

// 将对象转为key=value字符串，中间&连接
export function convertObj2Kv(obj, connector='&') {
  if (!obj || !Object.keys(obj).length) {
    return '';
  }
  
  const items = [];
  for(let [key, value] of Object.entries(obj)) {
    items.push(`${key}=${value}`);
  }
  return items.join(connector);
}

/**
 * 
 * @param {*} url 获取参数的URL
 * @param {*} excludedKeys 不获取的参数
 * @return [queryString, queryObject] 返回URL参数的字符串形式和对象形式
 */
export function getAllUrlParamObj(url, excludedKeys = []) {
  if (!url) {
    return {};
  }

  let queryStr = '';
  let queryObj = {};
  // 微信授权后，#前后可能都有参数
  url.split('#').forEach(item => {
    // 无问号时，说明当前部分没有参数。？前是路由部分，后是参数部分
    const queryPart = item.includes('?') ? item.split('?')[1] : '';

    if (queryPart) {
      queryStr += `&${queryPart}`;
    }
  })

  queryStr.split('&')
    .filter(item => !!item)
    .forEach((item) => {
      const params = item.split('=');
      if (!excludedKeys.includes(params[0])) {
        queryObj[params[0]] = params[1];
      }
    });

  return queryObj;
}

/**
 * 
 * @param {*} url 获取参数的URL
 * @param {*} excludedKeys 不获取的参数
 * @return [queryString, queryObject] 返回URL参数的字符串形式和对象形式
 */
export function getAllUrlParamStr(url, excludedKeys = []) {
  if (!url) {
    return '';
  }

  return convertObj2Kv(getAllUrlParamObj(url, excludedKeys));
}

// 防抖
export function debounce(func, ms = 1000) {
  let timer;
  return function(...args) {
    const context = this;
    clearTimeout(timer);

    timer = setTimeout(() => {
      func.apply(context, args);
    }, ms);
  }
}

// 节流
export function throttle(func, ms = 1000) {
  let timer;
  return function(...args) {
    if (timer) {
      return;
    }
    const context = this;
    timer = setTimeout(() => {
      func.apply(context, args);
      timer = null;
    }, ms);  
  }
}

export function getNameWithoutSuffix(fileName = '') {
  if (!fileName) {
    return '';
  }
  const dotIndex = fileName.lastIndexOf('.');
  if (dotIndex > -1) {
    fileName = fileName.substring(0, dotIndex);
  }
  return fileName;
}

export function assignValue (target = {}, source = {}) {
  Object.keys(target)
    .forEach(key => {
      if (source.hasOwnProperty(key)) {
        target[key] = source[key] === null ? undefined : source[key];
      }
    });
  return target;
}

export function cloneDeep(obj) {
  if (!obj) {
    return null;
  }
  let copy = null;
  try {
    copy = JSON.parse(JSON.stringify(obj));
  } catch (error) {
    console.log('colneDeep:', error);
  }
  return copy;
}

export function isIOS() {
  return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

// 两数之间随机数
export function randomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min; //含最大值，含最小值
}

// 是否微信H5
export function isInWX() {
  return /MicroMessenger/i.test(navigator.userAgent);
}

// 是否在移动端webview中
export function isInApp() {
  const mobileKeywords = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  return mobileKeywords.some(item => navigator.userAgent.includes(item));
}

export function isAndroid() {
  const androidKeywords = ['Android', 'Linux'];
  return androidKeywords.some(item => navigator.userAgent.includes(item));
}
